export const userServiceBaseUrl = process.env.REACT_APP_USER_API || "testuser.bangdb.com:18080";
export const cloudServiceBaseUrl =
  process.env.REACT_APP_CLOUD_SERVICE || "cloud.bangdb.com";
export const accessKey = "brs_access_key";
export const secretKey = "brs_secret_key";
export const appBucket = "_sys_app_files_bucket";

